import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=79f98a84"
import script from "./Groups.vue?vue&type=script&lang=js"
export * from "./Groups.vue?vue&type=script&lang=js"
import style0 from "./Groups.vue?vue&type=style&index=0&id=79f98a84&prod&lang=less"
import style1 from "./Groups.vue?vue&type=style&index=1&id=79f98a84&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports